export const MSSQLKeywords: string[] = [];
